import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const HeaderSectionTitle = styled.h2`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.headingH3)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin: 0;
`;

export const CaseDatesPanelContainer = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: column;
`;

export const CaseDateRow = styled.div`
  display: flex;
  gap: 20px;
`;

export const DatePickerContainer = styled.div`
  width: 50%;
`;
